require('./drop-file.less');

// reference: https://css-tricks.com/drag-and-drop-file-uploading/

jQuery(function() {
    // feature detection for drag&drop upload
    var isAdvancedUpload = (function() {
        var div = document.createElement('div');
        return (
            ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
            'FormData' in window &&
            'FileReader' in window
        );
    })();

    module.exports.setDropFile = function($dropContainer) {
        // applying the effect for every form
        $dropContainer.each(function() {
            var $this = $(this),
                $input = $this.find('input[type="file"]'),
                $textContainer = $this.find('.drop-file__text'),
                //$errorMsg	 = $this.find( '.box__error span' ),
                droppedFiles = false,
                showFiles = function(files) {
                    var $fileName = $textContainer.find('.drop-file__filename');
                    if ($fileName.length == 0) {
                        $textContainer.append('<div class="drop-file__filename" />');
                        $fileName = $textContainer.find('.drop-file__filename');
                    }

                    $fileName.text(
                        files.length > 1
                            ? ($input.attr('data-multiple-caption') || '').replace('{count}', files.length)
                            : files[0].name
                    );
                };

            // letting the server side to know we are going to make an Ajax request
            //$this.append( '<input type="hidden" name="ajax" value="1" />' );

            // automatically submit the form on file select
            $input.on('change', function(e) {
                showFiles(e.target.files);
            });

            // drag&drop files if the feature is available
            if (isAdvancedUpload) {
                $this
                    .addClass('has-advanced-upload') // letting the CSS part to know drag&drop is supported by the browser
                    .on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
                        // preventing the unwanted behaviours
                        e.preventDefault();
                        e.stopPropagation();
                    })
                    .on('dragover dragenter', function() //
                    {
                        $this.addClass('is-dragover');
                    })
                    .on('dragleave dragend drop', function() {
                        $this.removeClass('is-dragover');
                    })
                    .on('drop', function(e) {
                        droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
                        showFiles(droppedFiles);
                    });
            }
        });
    };
});



// WEBPACK FOOTER //
// ./blocks/drop-file/drop-file.js